module.exports = __webpack_public_path__ + "static/media/CostOpportunity_Angel_Mobile.79d87ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CostOpportunity_Angel_Mobile.png
// module id = 367
// module chunks = 0